import React, {  useEffect, useContext  } from "react";
import Create_List_Messaggi from './create_list_messaggi';
import helpers from "../_helpers/helpersFunction";
import Context from '../context/context';

export default function Chat_desktop(props) {
	const context = useContext(Context);

	useEffect(() => {  
		helpers.kpiPanel(context, "chat_list", null, true, null, { canon: "search_other_chats", dedup: true });
		//ReactGA.pageview('/lista_chat', "Lista chat");
	},[]);
	
	return (
		<div className="container padding_bottom filters-padding">
			<div className="row">
			<ul className="friend-list d-lg-block">
					{/*  ----- QUI ANDRO' AD INSERIRE I MATCH -----*/}
					<Create_List_Messaggi/>
			</ul>
			</div>
		
	</div>
	);
	
	
}